const CoupleTicketIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    fill="none"
    viewBox="0 0 20 21"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 4.667H1.666a.833.833 0 0 0-.833.833v13.334c0 .46.373.833.833.833H10c.46 0 .833-.373.833-.833V5.5A.833.833 0 0 0 10 4.667"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.808 7.161a1.21 1.21 0 0 1 2.359.383 1.1 1.1 0 0 1-.323.779L6.667 10.5h2.5M12.917 15.5h5.417a.833.833 0 0 0 .833-.833V1.333A.833.833 0 0 0 18.334.5H10a.833.833 0 0 0-.833.833V3"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.667 6.334v-3.75A.417.417 0 0 0 16 2.25L15 3M15.833 6.334H17.5"
    ></path>
    <path
      stroke="#000"
      d="M2.708 15.917a.208.208 0 0 1 0-.417M2.708 15.917a.208.208 0 0 0 0-.417M4.791 15.917a.208.208 0 0 1 0-.417M4.792 15.917a.208.208 0 0 0 0-.417M6.875 15.917a.208.208 0 0 1 0-.417M6.875 15.917a.208.208 0 0 0 0-.417M8.958 15.917a.208.208 0 0 1 0-.417M8.958 15.917a.208.208 0 0 0 0-.417M13.125 11.75a.208.208 0 0 1 0-.416M13.125 11.75a.208.208 0 0 0 0-.416M15.208 11.75a.208.208 0 0 1 0-.416M15.208 11.75a.208.208 0 0 0 0-.416M17.291 11.75a.208.208 0 0 1 0-.416M17.291 11.75a.208.208 0 0 0 0-.416"
    ></path>
  </svg>
);

export default CoupleTicketIcon;
